<template>
    <tr class="lms__superadmin_workspaces_list_table_item">
        <td class="lms__superadmin_workspaces_list_table_item_name">{{workspaceName}}</td>
        <td class="lms__superadmin_workspaces_list_table_item_customer">{{workspaceCustomer}}</td>
        <td class="lms__superadmin_workspaces_list_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <template v-if="user.isMasterAdministrator() && (loggedInUserTokenWorkspaceId !== workspaceId)">
                        <component-button
                            :name="`lms-superadmin-workspaces-list-table-item-actions-accessedit-${workspaceId}`"
                            :animate-loading="true"
                            :animate-loading-event-name="'access-workspace'"
                            @click="accessWorkspaceAndRedirect"
                        >Access and edit</component-button>
                    </template>
                    <template v-else>
                        <component-button
                            :to="{ name: 'lms-superadmin-workspace-edit', params: { id: workspaceId } }"
                            :name="`lms-superadmin-workspaces-list-table-item-actions-edit-${workspaceId}`"
                        >{{ $t('lms.workspace.buttons.edit') }}</component-button>
                    </template>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'

export default {
  name: 'lms-superadmin-workspace-list-table-item',
  components: { ComponentButton },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    loggedInUserTokenWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    workspaceCustomer () {
      const customer = this.item.customer
      return customer ? customer.name : ''
    },
    workspaceId () {
      return this.item.id
    },
    workspaceName () {
      return this.item.name
    },
    workspaceStatus () {
      return this.item.status
    }
  },
  methods: {
    switchWorkspace () {
      return this.$store.dispatch('authUserLoginSSOWorkspace', this.workspaceId).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Workspace accessed',
          status: 'success'
        })
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Workspace not accessed',
          message: 'There is a problem accessing this workspace. Please check you have access to this workspace.',
          status: 'error'
        })
      }).finally(() => {
        this.$eventBus.$emit('stop-access-workspace')
      })
    },
    accessWorkspaceAndRedirect () {
      this.switchWorkspace().then(response => {
        this.$router.push({ name: 'lms-superadmin-workspace-edit', params: { id: this.workspaceId } })
      })
    }
  }
}
</script>
